export const authHeaderTokenName = 'Bearer'
